import { useLoaderData } from 'react-router';

import { cn } from '@rocco/utils/cn';
import type { loader } from '~/routes/_app.product.$urlSegment';
import { CONTENT_CAP_PADDED } from '~/ui-rocco/pages/detail-shared';
import { SectionHead } from '~/ui-rocco/pages/detail-shared/SectionHead';
import { SimilarProductsRowContent } from './spec-accordion/SimilarProductsRowContent';

/**
 * (04) THE CATEGORY — the rest of the category, under the same head the range
 * gets. Out of the accordion for the same reason: a one-line row label was
 * doing the work of a section title.
 *
 * Both orders set it: mobile names it "More products in", in step with the
 * supplier's "More products from" above it.
 */
export const MoreInCategorySection = ({
    lead = 'More in',
    runIn,
}: {
    /** The head's first line; the category is always the second. */
    lead?: string;
    /** The air above the head, as padding classes. */
    runIn?: string;
} = {}) => {
    const { primaryCategory } = useLoaderData<typeof loader>();
    const category = primaryCategory?.PrettyTitle;

    if (!category) return null;

    return (
        <section className={cn('bg-ground max-md:px-6 md:px-[3rem]', runIn)}>
            <div className={CONTENT_CAP_PADDED}>
                <SectionHead
                    lead={lead}
                    subject={category}
                    mobileMutedSubject
                    hideMobileStandfirst
                    subjectLink={primaryCategory?.Link}
                    standfirst={`Everything else in ${category}, from every supplier on ArchiPro.`}
                />

                <div className="max-md:mt-8 md:mt-[4rem]">
                    <SimilarProductsRowContent />
                </div>
            </div>
        </section>
    );
};
